/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function AlignItemsTop({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g fill="currentColor" fillRule="evenodd" clipPath="url(#AlignItemsTop_svg__a)" clipRule="evenodd"><path d="M7.1 3v10A2.1 2.1 0 0 1 5 15.1H3A2.1 2.1 0 0 1 .9 13V3C.9 1.84 1.84.9 3 .9h2c1.16 0 2.1.94 2.1 2.1M5.9 13V3a.9.9 0 0 0-.9-.9H3a.9.9 0 0 0-.9.9v10a.9.9 0 0 0 .9.9h2a.9.9 0 0 0 .9-.9M15.1 3v6a2.1 2.1 0 0 1-2.1 2.1h-2A2.1 2.1 0 0 1 8.9 9V3c0-1.16.94-2.1 2.1-2.1h2c1.16 0 2.1.94 2.1 2.1m-1.2 6V3a.9.9 0 0 0-.9-.9h-2a.9.9 0 0 0-.9.9v6a.9.9 0 0 0 .9.9h2a.9.9 0 0 0 .9-.9" /></g><defs><clipPath id="AlignItemsTop_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;